import React, { useEffect, useMemo } from "react";
import { COMMON_WEB_PATH } from "../../../constant";
import { Box, Image } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { toggleBGM } from "../../../redux/action/action";
import useCheckLogin from "../../../hook/useCheckLogin";
import { Link } from "react-router-dom";
import i18next from "i18next";

const LoginButton = () => {
  const { isMachineUser } = useCheckLogin();

  const iconSize = useMemo(() => {
    return {
      base: "50px",
      md: "50px",
      xl: isMachineUser ? "80px" : "80px",
    };
  }, [isMachineUser]);

  return (
    <Link
      to="signin"
      position="relative"
      cursor="pointer"
      display="flex"
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Image
        src={`${COMMON_WEB_PATH}/now888/header/login_button${
          i18next.language == "tw" ? "" : `_${i18next.language}`
        }.png`}
        height={iconSize}
        //minW="50px"
        minW={iconSize}
        // maxW={iconSize}
      />
    </Link>
  );
};

export default LoginButton;
